import { ReactNode } from "react";
import { COLORS } from "@/components/home/LayerIndexCard";

export const stateColor = (label?: string | null) => COLORS[label || ""] || "#A3A3A3";

export const stateWord = (v: number | null | undefined): [string, string] => {
  if (v == null) return ["—", "#6b7488"];
  if (v >= 70) return ["Strong", "#34D399"];
  if (v >= 55) return ["Firm", "#6EE7B7"];
  if (v >= 45) return ["Neutral", "#A3A3A3"];
  if (v >= 30) return ["Soft", "#F87171"];
  return ["Weak", "#EF4444"];
};

export const signed = (n: number | null | undefined, digits = 0) =>
  n == null ? "—" : `${n > 0 ? "+" : ""}${digits ? n.toFixed(digits) : n}`;

export const deltaColor = (d: number | null | undefined) =>
  d == null || d === 0 ? "#8b93ad" : d > 0 ? "#34D399" : "#F87171";

export const AURORA_BAR = "linear-gradient(90deg,#7B2CFF,#435CFF,#05D1E5)";

export const Section = ({ num, title, sub, children, testid }: {
  num: string; title: string; sub?: string; children: ReactNode; testid: string;
}) => (
  <section className="mt-16 sm:mt-24" data-testid={testid}>
    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 border-b border-white/[0.08] pb-4">
      <span className="nl-mono text-[10px] font-bold tracking-[0.3em] text-[#A78BFA]">{num}</span>
      <h2 className="font-news font-black text-white text-lg tracking-tight">{title}</h2>
      {sub && (
        <p className="nl-mono text-[9.5px] uppercase tracking-[0.18em] text-gray-600 ml-auto hidden sm:block">
          {sub}
        </p>
      )}
    </div>
    <div className="mt-8">{children}</div>
  </section>
);
